import React, { useState } from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Area
} from "recharts";
import "./LineCharts.css";

const LineCharts = ({ relatedData }) => {
    const [selectedY, setSelectedY] = useState("potrosnja_mjesecna_amt");

    // Mape između opcija i njihovih labela za dropdown
    const options = {
        potrosnja_mjesecna_amt: "Potrošnja (AMT)",
        potrosnja_mjesecna_avt: "Potrošnja (AVT)",
        obracunska_snaga: "Obračunska snaga",
        obracunata_prekovremena_rvt: "Prekovremena (RVT)"
    };

    // Filtriranje duplikata na osnovu "obracunski_period"
    const uniqueData = relatedData.filter(
        (item, index, self) =>
            index ===
            self.findIndex(
                (t) => t.properties.obracunski_period === item.properties.obracunski_period
            )
    );

    // Priprema podataka za linijski dijagram
    const chartData = uniqueData.map((item) => ({
        obracunski_period: item.properties.obracunski_period,
        value: item.properties[selectedY] || 0
    }));

    // Funkcija za formatiranje X-ose
    const formatXAxis = (tickItem) => {
        const monthMapping = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const dateParts = tickItem.split("-");
        if (dateParts.length > 0) {
            const startDate = dateParts[0].trim();
            const monthNumber = parseInt(startDate.split(".")[1], 10);
            return monthMapping[monthNumber - 1];
        }
        return tickItem;
    };

    // Prilagođeni Tooltip
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip">
                    <p className="label">
                        <strong>Period:</strong> {label}
                    </p>
                    <p className="label">
                        <strong>Utrošak energije:</strong> {payload[0].value} kWh
                    </p>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="line-chart-container">
            <h6>GRAFIKON MJERENJA</h6>
            <div className="readings">
                <label style={{ color: "#fff", marginLeft: "0" }}>Parametar potrošnje: </label>
                <select
                    value={selectedY}
                    onChange={(e) => setSelectedY(e.target.value)}
                    className="readings"
                >
                    {Object.entries(options).map(([key, label]) => (
                        <option key={key} value={key}>
                            {label}
                        </option>
                    ))}
                </select>
            </div>
            <ResponsiveContainer width="100%" height={200} style={{ marginLeft: "-20px" }}>
                <LineChart data={chartData}>
                    <defs>
                        <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#00e09e" stopOpacity={0.8} />
                            <stop offset="100%" stopColor="#00e09e" stopOpacity={0} />
                        </linearGradient>
                    </defs>
                    {/* Minimalistički dizajn */}
                    <XAxis
                        dataKey="obracunski_period"
                        tickFormatter={formatXAxis}
                        tick={{ fill: "#fff" }}
                        axisLine={{ stroke: "#fff" }}
                        tickLine={{ stroke: "#fff" }}
                    />
                    <YAxis
                        tick={{ fill: "#fff" }}
                        axisLine={{ stroke: "#fff" }}
                        tickLine={{ stroke: "#fff" }}
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <Area
                        type="monotone"
                        dataKey="value"
                        stroke="#00e09e"
                        fill="url(#colorValue)"
                        strokeWidth={3}
                    />
                    <Line
                        type="monotone"
                        dataKey="value"
                        stroke="#00e09e"
                        strokeWidth={3}
                        dot={false}
                        activeDot={{ r: 4, stroke: "#00e09e", strokeWidth: 2 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default LineCharts;
